import React, { Component } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const Pager = (props) => {

    function getPaginationItems(){
        let result = [];
        result.push(<PaginationItem key={-1} disabled={props.currentPage == 1}><PaginationLink previous onClick={(e) => props.onPageChanged(props.currentPage - 1)} /></PaginationItem>);
        for (let index = 0; index < props.totalPages; index++) {
            result.push(<PaginationItem key={index} active={index + 1 == props.currentPage}><PaginationLink onClick={(e) => props.onPageChanged(index + 1)}>{index + 1}</PaginationLink></PaginationItem>);
        }
        result.push(<PaginationItem key={9999999999} disabled={props.currentPage == props.totalPages}><PaginationLink next onClick={(e) => props.onPageChanged(props.currentPage + 1)}/></PaginationItem>);
        return result;
    }

    return (
        <>
            <div style={{padding:'1rem'}}>
                <label>סה"כ שורות: {props.totalRows}</label>
            </div>

            {props.totalPages > 1 ?
                <div className="mx-auto" style={{width:'fit-content'}}>
                    <Pagination >
                        {getPaginationItems()}
                    </Pagination>
                </div> : null }

            <div className="mx-auto text-center" style={{marginBottom:'6rem'}}>
                <label htmlFor="drpPageSize">בחר מספר שורות</label>
                <select className="col-md-1 col-sm-2 form-control mx-auto" style={{backgroundColor:'transparent'}} id="drpPageSize" value={props.pageSize} onChange={(e) => props.onPageSizeChanged(e.target.value)}>
                    {props.pageSizes.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
            </div>
        </>
    );
  };
  
  export default Pager;
  